<template>
  <el-select 
    v-model="val" 
    class="AGlassThicknessSelector inline" 
    placeholder="두께"
    size="mini"
    @change="change">
    <el-option 
      v-for="item in items" 
      :key="item.id" 
      :label="item.name" 
      :value="item.id" 
    />
  </el-select>
</template>
<script>
import { mapGetters } from "vuex";
import { selector } from "@/common/mixins/selector";

export default {
  name: "AGlassThicknessSelector",
  mixins: [selector],  
  props: {
    product_id: {
      type: Number,
    },
    glass_color_id: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters(["table_product_glass_price", "table_glass_thickness"]),
    items: function() {
      let items = [];
      if (!this.product_id || !this.glass_color_id) {
        return items;
      }
      let thicknesses = this.table_product_glass_price
        .filter(p => p.product_id === this.product_id && p.glass_color_id === this.glass_color_id)
        .map(p => p.glass_thickness_id);        
      if (thicknesses.length < 1) {
        return items;
      }
      items = this.table_glass_thickness.filter(t=> thicknesses.includes(t.id));
      return items.sort(this.sort);
    }
  },  
  methods: {
    sort(a, b) {
      let ta = Number.parseFloat(a.name);
      let tb = Number.parseFloat(b.name);
      return ta - tb;
    }
  }
};
</script>
